const frCommon = {
  site_name: "Hipobuy Spreadsheet",
  nav_home: "Accueil",
  nav_categories: "Catégories",
  nav_guides: "Guide d'achat",
  nav_contact: "Contact",
  nav_articles: "Articles SEO",
  cta_main_site: "hipobuy spreadsheet",
  cta_buy_now: "buy it now",
  cta_access: "Accéder au site principal",
  cta_start: "Commencer maintenant",
  footer_copyright: "© 2026 Hipobuy Spreadsheet. Tous droits réservés.",
  footer_privacy: "Politique de confidentialité",
  footer_terms: "Conditions d'utilisation",
  read_more: "Lire l'article",
  back_home: "← Retour à l'accueil",
  voir_plus: "Voir plus d'articles",
};

export default frCommon;